import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { strings } from '../../../localization';

export default class OverdueError extends Component {

    render() {
        return (
            <div className="page-error">
                <h2>{strings.account_overdue_title}</h2>
                <hr />
                <p>{strings.account_overdue_description}</p>
                <p>{strings.account_overdue_please_contact_support}</p>
            </div>
        );
    }
}
